module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_bacterial_cell_1-ba86fe0ae282960db1f18450b989f0eb.jpg";